import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import axios from 'axios'

// Import serviços primeiro para inicializar a sessão
import sessionService from './services/session.service'
import authService from './services/auth.service'

// Verificar se existe uma sessão válida

// Configuração global do Axios
// O endereço da API é definido no ambiente de publicação e mantém o padrão local
// para o desenvolvimento na máquina.
axios.defaults.baseURL = process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'production' ? 'https://api.oscrm.casdev.com.br' : 'http://localhost:5000')
axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.timeout = 30000 // 30 segundos de timeout
axios.defaults.maxRetries = 3
axios.defaults.retryDelay = 1000

// Adicionar o token de autenticação aos headers padrão se existir
const token = sessionService.getToken()
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

// Interceptador para logs e gerenciamento de erros
axios.interceptors.request.use(
  config => {
    // Obter token diretamente do serviço de sessão para cada requisição
    const token = sessionService.getToken()
    if (token) {
      config.headers['Authorization'] = token
    }
    // Adiciona contador de tentativas se não existir
    config.retryCount = config.retryCount || 0
    return config
  },
  error => {
    console.error('[Axios] Erro na requisição:', error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => response,
  error => {
    const config = error.config

    // Verifica se podemos tentar novamente a requisição
    if (error.response?.status === 401 && config && !config.url?.includes('/login') && !config.url?.includes('/register')) {
      sessionService.clear()
      router.push('/login')
      return Promise.reject(error)
    }
    const status = error.response?.status
    const safeMethod = (config?.method || 'get').toLowerCase() === 'get'
    const retryable = !status || status === 429 || status >= 500
    if (!config || !safeMethod || !retryable || !axios.defaults.maxRetries || config.retryCount >= axios.defaults.maxRetries) {
      return Promise.reject(error)
    }

    // Incrementa contador de tentativas
    config.retryCount += 1

    // Cria uma nova promessa para atrasar a nova tentativa
    return new Promise(resolve => {
      setTimeout(() => resolve(axios(config)), axios.defaults.retryDelay || 1000)
    })
  }
)

// PrimeVue Components
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Menu from 'primevue/menu'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Message from 'primevue/message'
import ProgressSpinner from 'primevue/progressspinner'
import ProgressBar from 'primevue/progressbar'
import Tag from 'primevue/tag'
import Timeline from 'primevue/timeline'
import Chart from 'primevue/chart'
import Avatar from 'primevue/avatar'
import Textarea from 'primevue/textarea'
import Calendar from 'primevue/calendar'
import Checkbox from 'primevue/checkbox'
import Rating from 'primevue/rating'
import InputNumber from 'primevue/inputnumber'
import TabMenu from 'primevue/tabmenu'
import MultiSelect from 'primevue/multiselect'
import Slider from 'primevue/slider'
import Chips from 'primevue/chips'

const app = createApp(App)

// Registrar componentes globais
app.component('Button', Button)
app.component('InputText', InputText)
app.component('Password', Password)
app.component('Dropdown', Dropdown)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('Menu', Menu)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('Message', Message)
app.component('ProgressSpinner', ProgressSpinner)
app.component('ProgressBar', ProgressBar)
app.component('Tag', Tag)
app.component('Timeline', Timeline)
app.component('Chart', Chart)
app.component('Avatar', Avatar)
app.component('Textarea', Textarea)
app.component('Calendar', Calendar)
app.component('Checkbox', Checkbox)
app.component('Rating', Rating)
app.component('InputNumber', InputNumber)
app.component('TabMenu', TabMenu)
app.component('MultiSelect', MultiSelect)
app.component('Slider', Slider)
app.component('Chips', Chips)

// Configurar plugins e serviços
app.use(router)
app.use(store)
app.use(PrimeVue, { ripple: true })
app.use(ConfirmationService)
app.use(ToastService)

// Adicionar instâncias globais
app.config.globalProperties.$axios = axios
app.config.globalProperties.$auth = authService
app.config.globalProperties.$session = sessionService
app.config.globalProperties.$confirm = app.config.globalProperties.$confirmationService

app.mount('#app') 
